export default {"src":"/_next/static/media/delete.69d555bb.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};